<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />

    <div class="bodyCenter">
      <div class="modalStyle">
        <div class="headerTitle">
          <div class="seccionTitle">
            <b-icon icon="card-checklist" class="mLeft"></b-icon>
            <div class="headerTxt mLeft">REPORTE REQUISICIÓN</div>
          </div>
          <div class="alignIcon bold">RR_01</div>
        </div>

        <b-row class="noAlTope" v-if="cargandoInicio">
          <b-col>
            <b-button variant="primary" disabled>
              <b-spinner small></b-spinner>
              Cargando...
            </b-button>
          </b-col>
        </b-row>

        <div class="noAlTope" v-else>
          <b-form v-on:submit.prevent="buscarDatos">
            <b-row>
              <b-col>
                <label>Fecha inicio:</label>
                <b-form-datepicker
                  class="text-left"
                  v-model="inicio"
                  :min="minInicio"
                  :max="hoy"
                  :state="inicio != null"
                  placeholder="Selecciona una fecha"
                  required
                ></b-form-datepicker>
                <b-form-invalid-feedback :state="inicio != null">
                  Debe seleccionar una fecha
                </b-form-invalid-feedback>
              </b-col>
              <b-col>
                <label> Fecha fin: </label>
                <b-form-datepicker
                  class="text-left"
                  v-model="fin"
                  :min="minInicio"
                  :max="hoy"
                  :state="fin != null"
                  placeholder="Selecciona una fecha"
                  required
                ></b-form-datepicker>
                <b-form-invalid-feedback :state="fin != null">
                  Debe seleccionar una fecha
                </b-form-invalid-feedback>
              </b-col>
              <b-col>
                <label>Clínica: </label>
                <b-form-select
                  v-model="idClinica"
                  :options="listaClinica"
                  value-field="idClinica"
                  text-field="strNombre"
                  :state="idClinica != null"
                  required
                >
                </b-form-select>
                <b-form-invalid-feedback :state="idClinica != null">
                  Debe seleccionar una opción
                </b-form-invalid-feedback>
              </b-col>
              <b-col>
                <label>Tipo de requisición: </label>
                <b-form-select
                  v-model="tipoRequisicion"
                  :options="listaTipoRequisicion"
                  value-field="idTipo"
                  text-field="nombre"
                  :state="tipoRequisicion != null"
                  required
                >
                </b-form-select>
                <b-form-invalid-feedback :state="tipoRequisicion != null">
                  Debe seleccionar una opción
                </b-form-invalid-feedback>
              </b-col>
            </b-row>

            <b-row class="mb-4 mt-4">
              <b-col>
                <b-button variant="outline-primary" v-if="cargando" disabled>
                  <b-spinner small></b-spinner>
                  Cargando...
                </b-button>

                <b-button type="submit" variant="outline-primary" v-else>
                  Buscar
                </b-button>
              </b-col>
            </b-row>
          </b-form>

          <b-alert v-if="requisicion.length == 0" variant="danger" show>
            No hay datos
          </b-alert>
          <div v-else>
            <b-table
              striped
              hover
              thead-tr-class="columnas"
              :items="requisicion"
              :fields="titulosRequisicion"
              :per-page="perPageHistorial"
              :current-page="currentPageHistorial"
            >
              <template v-slot:cell(fechaAlta)="row">
                {{ row.item.fechaAlta | formatoFecha }}
              </template>
            </b-table>
            <b-pagination
              v-model="currentPageHistorial"
              :total-rows="requisicion.length"
              :per-page="perPageHistorial"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../components/Header";
import VueNotifications from "vue-notifications";

export default {
  name: "reporteRequisiciones",
  components: {
    Header,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    inicio: null,
    fin: null,
    tipoRequisicion: null,
    idClinica: null,
    listaClinica: [],
    listaTipoRequisicion: [],
    requisicion: [],
    titulosRequisicion: [
      {
        key: "cantidad",
        label: "Cantidad",
      },
      {
        key: "descripcion",
        label: "Descripción",
        sortable: true,
      },
      {
        key: "cantidadAutorizada",
        label: "Cantidad autorizada",
      },
      {
        key: "fechaAlta",
        label: "Fecha alta",
        sortable: true,
      },
      {
        key: "stock",
        label: "Stock",
      },
      {
        key: "estatus",
        label: "Estatus",
      },
    ],
    perPageHistorial: 10,
    currentPageHistorial: 1,
    hoy: new Date(),
    minInicio: null,
    cargando: false,
    cargandoInicio: true,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();

    const minDate = new Date();
    minDate.setMonth(minDate.getMonth() - 1);
    this.minInicio = minDate;

    this.traerCatalogos();
  },
  methods: {
    traerCatalogos() {
      const listaTipo = [
        { idTipo: null, nombre: "Tipo de Requisición:" },
        { idTipo: false, nombre: "Ordinario" },
        { idTipo: true, nombre: "Extraordinario" },
      ];
      this.listaTipoRequisicion = listaTipo;

      const url = this.$api + "catalogos/listaClinicas";
      this.$http
        .get(url)
        .then((response) => {
          if (response.status === 200) {
            response.data.data.unshift({
              idClinica: null,
              strNombre: "Clínica :",
            });

            this.listaClinica = response.data.data;
          }
        })
        .catch((err) => {
          this.showErroMsg(err);
        })
        .finally(() => {
          this.cargandoInicio = false;
        });
    },
    buscarDatos() {
      if (!this.validarDatos()) {
        this.cargando = true;
        const url = this.$api + "reportes/requisiciones";

        this.$http
          .post(url, this.traerDatos())
          .then((response) => {
            if (response.data.data) {
              this.requisicion = response.data.data;
            }
          })
          .catch((err) => {
            this.errorEnvio(err);
          })
          .finally(() => {
            this.cargando = false;
          });
      } else {
        this.$swal({
          icon: "warning",
          text: "Debe seleccionar ambas fechas",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });
      }
    },
    validarDatos() {
      let error = false;
      if (this.fin == null || this.inicio == null) {
        error = true;
      }

      return error;
    },
    traerDatos() {
      const fin = new Date(this.fin);
      fin.setDate(fin.getDate() + 2);

      return {
        idClinica: this.idClinica,
        fechaInicio: this.$global.traerFecha(this.inicio),
        fechaFinal: this.$global.traerFecha(fin),
        tipoRequisicion: this.tipoRequisicion,
      };
    },
  },
  notifications: {
    errorEnvio: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al enviar la información",
    },
  },
};
</script>
